let itemsData = [{
  "sku_id": 1000271,
  "title": "远程电子钥匙",
  "sub_title": "按键，4G模块，实时授权，上报开锁记录",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-SC-KEY-1',
  "ali_images": [
    {'image':require('@/assets/img/products/remotekey/screen/screenkey2.gif')},
    {'image':require('@/assets/img/products/remotekey/screen/screenkey1.gif')},
    {'image':require('@/assets/img/products/remotekey/screen/sc-key-demo.png')},
    {'image':require('@/assets/img/products/remotekey/screen/screenkey1.jpg')},
    
//  {'image':require('@/assets/img/item/cba7b4cdb2fc41d7f29fb45d94972e41.jpg')},
  ],
  'tech':[
    '屏幕显示，按键操作菜单',
    '4G模块，插入SIM卡，即可连接网络',
    '超低功耗蓝牙芯片开发，待机电流小于35uA',
    '内置3.7V可充电锂电池，容量800mAH。充电接口TYPE-C',
    '语音提示功能。如“认证成功”，“开锁成功”，“不在有效期”等',
    '开锁数据双重加密，随机变化',
  ],
  'pdf_url':'4G-SC-KEY01.pdf'
},{
  "sku_id": 1000299,
  "title": "远程电子钥匙",
  "sub_title": "指纹认证，4G模块，实时授权，上报开锁记录",
  "ali_image": "http://image.smartisanos.cn/resource/ae40a16324658c192c7361d829f603bd.jpg",
  "model": 'CG-FG-KEY-1',
  "ali_images": [
    {'image':require('@/assets/img/products/remotekey/finger/finger-key1.jpg')},
    {'image':require('@/assets/img/products/remotekey/finger/finger-key2.jpg')},
    {'image':require('@/assets/img/products/remotekey/finger/finger-key3.jpg')},
    {'image':require('@/assets/img/products/remotekey/finger/4g-fg-key-dem.png')},
    {'image':require('@/assets/img/products/remotekey/finger/finger-key4.jpg')},
  ],
  'tech':[
    '指纹认证开机，最多录入20枚指纹',
    '4G模块，插入SIM卡，即可连接网络',
    '超长待机，超低功耗蓝牙芯片开发，待机电流小于35uA',
    '内置3.7V可充电锂电池，容量800mAH。充电接口TYPE-C',
    '语音提示功能。如“认证成功”，“开锁成功”，“不在有效期”等',
    '开锁数据双重加密，随机变化',
    'OTA升级钥匙固件',
  ],
  'pdf_url':'4G-FG-KEY01.pdf'
},
{
  "sku_id": 1000300,
  "title": "远程电子钥匙",
  "sub_title": "按键，4G模块，实时授权，上报开锁记录",
  "ali_image": require('@/assets/img/products/remotekey/buttonkey/btn-key1.jpg'),
  "model": 'CG-BT-KEY-1',
  "ali_images": [
    {'image':require('@/assets/img/products/remotekey/buttonkey/btn-key1.jpg')},
    {'image':require('@/assets/img/products/remotekey/buttonkey/btn-key2.jpg')},
    {'image':require('@/assets/img/products/remotekey/buttonkey/btn-key3.jpg')},
    {'image':require('@/assets/img/products/remotekey/buttonkey/btn-key-demo.png')},
    {'image':require('@/assets/img/products/remotekey/buttonkey/BTN-KEY.jpg')},
  ],
  'tech':[
    '4G模块，插入SIM卡，连接网络',
    '超长待机，超低功耗蓝牙芯片开发，待机电流小于25uA',
    '内置3.7V可充电锂电池，容量800mAH。充电接口TYPE-C',
    '语音提示功能。如“认证成功”，“开锁成功”，“不在有效期”等',
    '开锁数据双重加密，随机变化',
    'OTA升级钥匙固件',
  ],
  'pdf_url':'4G-BT-KEY01.pdf'
}
]

export default itemsData



// WEBPACK FOOTER //
// ./src/lib/remoteKeysDetailData.js